// Allocations API — endpoints injected into the single baseApi (ARCHITECTURE §7).
import { baseApi } from '@/lib/api/baseApi';
import { allocationsEndpoints } from './allocations.queries';

export const allocationsApi = baseApi.injectEndpoints({ endpoints: allocationsEndpoints });

export const {
  useGetAllocationsQuery,
  useGetAllocationFilterOptionsQuery,
  useGetAllocationDetailQuery,
  useGetAllocationDeclarationQuery,
  useLazyGetAllocationDeclarationQuery,
  useGetAllocationAttachmentsQuery,
  useRevokeAllocationMutation,
  useRejectAllocationMutation,
  useUploadAllocationDeclarationFileMutation,
  useSaveAllocationDeclarationMutation,
  useLazyGetAllocationDeclarationFileQuery,
  useBulkGenerateAllocationDeclarationsMutation,
  useCreateAllocationShipmentMutation,
} = allocationsApi;
